import { apiEndpoints } from "@/services/api/api";
import { ActionFunctionArgs } from "react-router-dom";
import { reOrderDataDTO } from "../types/manageCourseActionTypes";

export async function AdminManageCourseAction({ request }: ActionFunctionArgs) {
  const formData = await request.formData();
  const intent = formData.get("intent");
  formData.delete("intent");

  switch (intent) {
    case "reOrderSection": {
      try {
        const id = formData.get("id") as string;
        const orderNumberStr = formData.get("orderNumber") as string;
        const orderNumber = parseInt(orderNumberStr, 10);

        if (!id || orderNumberStr === null || isNaN(orderNumber)) {
          throw new Error("id veya orderNumber eksik veya geçersiz");
        }

        const objectToTransfer: reOrderDataDTO = {
          id: id,
          orderNumber: orderNumber,
        };
        const result =
          await apiEndpoints.lecturerReOrderSection(objectToTransfer);
        if (!result.success) {
          throw new Error("Section sıralaması sırasında bir hata oluştu.");
        }
        return result.success;
      } catch (err) {
        throw err;
      }
    }
    case "reOrderLecture": {
      try {
        const id = formData.get("id") as string;
        const orderNumberStr = formData.get("orderNumber") as string;
        const orderNumber = parseInt(orderNumberStr, 10);
        if (!id || orderNumberStr === null || isNaN(orderNumber)) {
          throw new Error("id veya orderNumber eksik veya geçersiz");
        }

        const objectToTransfer: reOrderDataDTO = {
          id: id,
          orderNumber: orderNumber,
        };
        const result = await apiEndpoints.reOrderLecture(objectToTransfer);
        if (!result.success) {
          throw new Error("Section sıralaması sırasında bir hata oluştu.");
        }
        return result.success;
      } catch (err) {
        console.error("Section sıralama hatası:", err);
        throw err;
      }
    }
    case "delete-section": {
      const id = formData.get("id") as string;
      if (!id) throw new Error("Section ID is required for deletion.");
      try {
        const result = await apiEndpoints.lecturerDeleteSection(id);
        if (!result.success) {
          throw new Error("Section silinirken bir hata oluştu.");
        }
        return result;
      } catch (err) {
        throw err;
      }
    }

    case "delete-lecture": {
      const id = formData.get("id") as string;
      if (!id) throw new Error("Lecture ID is required for deletion.");
      try {
        const result = await apiEndpoints.lecturerDeleteLecture(id);
        if (!result.success) {
          throw new Error("Lecture silinirken bir hata oluştu.");
        }
        return result;
      } catch (err) {
        throw err;
      }
    }

    default:
      throw new Error("Unknown intent");
  }
}
